import React, { FC }              from 'react';
import { useFetchInvoiceHistory } from '@modules/invoiceManagement/queries/invoiceManagementQueries';
import { InvoiceHistoryPage }     from '../pages/InvoiceHistoryPage';

interface IProps {
  push: (path: string) => void;
}

export const InvoiceHistoryContainer: FC<IProps> = ({ push }) => {
  const {
    data: invoiceHistory = [],
    isLoading,
  } = useFetchInvoiceHistory();

  return (
    <InvoiceHistoryPage
      invoiceHistory  = {invoiceHistory}
      isLoading       = {isLoading}
      push            = {push}
    />
  );
};
